import { BestStock } from '@benzinga/content-manager';
import { TickerBox } from '../Blocks/QuotesBlock';
import MoneyPostTemplate from './MoneyPostTemplate';
import { MoneyTemplateProps } from '../../entities';

export const BestStocksTemplate: React.FC<MoneyTemplateProps> = ({ post }) => {
  return (
    <MoneyPostTemplate
      layoutAboveArticle={
        post?.best_stocks && (
          <div>
            {Array.isArray(post?.best_stocks?.highlighted_stocks) &&
              post?.best_stocks?.highlighted_stocks?.map((pick: BestStock) => {
                return (
                  <TickerBox
                    description={pick.description}
                    initialQuote={pick.quote}
                    key={pick.stock}
                    symbol={pick.stock}
                  />
                );
              })}
          </div>
        )
      }
      post={post}
    />
  );
};

export default BestStocksTemplate;
